// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Account: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 23 26"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M23 17.254v8.747H0v-8.747c0-2.478 4.313-3.935 9.344-4.373l2.156 5.126 2.156-5.126C18.687 13.32 23 14.776 23 17.254M17.25 5.831c0 3.22-2.575 5.83-5.75 5.83s-5.75-2.61-5.75-5.83S8.325 0 11.5 0s5.75 2.61 5.75 5.83"
            />
        </svg>
    );
};

export default React.memo(Account);
